<div class="main-container">
    <p class="global-title">Langues Vivantes Interlingua<p>
    <p>TVA intracommunautaire: BE 0448.926.985</p>
</div>